import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: (style) => ({
    ...{ ...style, position: "absolute !important" },
    "& .MuiBackdrop-root": { ...style, position: "absolute" }
  }),
  backdrop: { zIndex: theme.zIndex.drawer - 1 },
  dialogPaper: {
      // height:(style)=> style?.popupStyle?.AdvListviewPopupAutoHeight === "true" || style?.popupStyle.ListviewPopupHeight === "true"? 'auto': (style?.popupStyle?.height ? `${style?.popupStyle?.height}%` :(style?.gridStyle?.GridModalType !== "belowSection" && style?.gridStyle.GridModalType !== "aboveSection") ? `${style?.popupStyle?.height || 300}px` : 'auto'),
      height:(style)=> style?.popupStyle?.AdvListviewPopupAutoHeight === "true" || style?.popupStyle.ListviewPopupHeight === "true"? 'auto': style?.popupStyle?.height ? 
        (style?.gridStyle?.GridModalType !== "belowSection" && style?.gridStyle.GridModalType !== "aboveSection") ? `${style?.popupStyle?.height}%`:`${style?.popupStyle?.height || 300}px`:"auto",
    // height: (style) =>
    //   style?.gridStyle?.GridModalType !== "belowSection" && style?.gridStyle.GridModalType !== "aboveSection"
    //     ? style?.popupStyle?.AdvListviewPopupAutoHeight === "true" || style?.popupStyle.ListviewPopupHeight === "true" 
    //       ? "auto"
    //       : `${style?.popupStyle?.height || 300}px`
    //     : style?.popupStyle?.height
    //     ? `${style?.popupStyle?.height}%`
    //     : "auto",
    width: (style) =>
      style?.gridStyle?.GridModalType === "belowSection" && style?.gridStyle.GridModalType === "aboveSection"
        ? "100%"
        : style?.popupStyle?.width
        ? `${style?.popupStyle?.width}%`
        : "90%",
    maxWidth: "unset",
    maxHeight:(style) => style?.popupStyle?.height ? "100%" : "80%",
    borderRadius: "2px",
    margin: "0",
    overflowY:"unset !important"
  },
  gridButtons: {
    "& .primaryBtn": {
      color: (prop) => prop.primaryColor,
      backgroundColor: (prop) => prop.primaryBackgroundColor,
      borderColor: (prop) => prop.primaryBorderColor,

      "&:focus": { boxShadow: (prop) => `0 0 5px 0px ${prop.primaryBorderColor}` }
    },

    "& .secondaryBtn": {
      color: (prop) => prop.secondaryColor,
      borderColor: (prop) => prop.secondaryBorderColor,

      "&:focus": { boxShadow: (prop) => `0 0 5px 0px ${prop.secondaryBorderColor}` }
    }
  },

  // listview popup style -- starts
  listviewHeader: {
    height: "50px",
    display: "flex",
    alignItems: "center",
    fontFamily: "Open Sans",
    paddingLeft: "0px !important",
    justifyContent: "space-between",
    marginRight: (style) => (style.isArabic ? "15px" : ""),
    marginLeft: (style) => (style.isArabic ? "15px" : "")
  },
  dialogTitle: {
    fontSize: "14px",
    fontWeight: "600",
    paddingLeft: "16px",
    paddingTop: "0px"
  },
  crossListviewPopUp: { paddingtop: "0px" },
  defaultImageCrossSubformListView: {
    marginRight: "16px",
    height: "10px",
    width: "10px",
    cursor: "pointer"
  },
  dialogContent: {
    padding: "0px",
    minHeight: "200px",
    position: "relative",
    border: "none",
    overflowX: "hidden",
    maxHeight: (style) => (style.isMobile || style.isTablet ? "75vh" : "unset")
  },
  dialogContentIsLoading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
  // listview popup style -- ends
}));
